<template>
    <div data-cy="container_mission_checkin_detail">
        <div class="text-center text-18 font-bold text-white" data-cy="text_mission_checkin_title">
            {{lbl.mission.title_mission}}
        </div>
        <div class="text-center text-14 underline font-regular text-white pt-2 pb-4" data-cy="btn_mission_checkin_detail" @click="clickDetail()">
            {{lbl.mission.detail}}
        </div>
        <!-- prograss bar -->
        <!-- <div id="progress_bar">
            <div id="current_bar"
                :style="{'width': `${progressMission}%`}"
                class="bg-gradient-to-r from-a-yellow-ffca66 to-a-yellow-ffeb3c">
            </div>
            <div class="icon-fish" :style="{'margin-left': `${progressMission}%`}">
                <img src="../../../assets/image/img-progress-bar.svg">
            </div>
        </div>
        <div class="flex justify-between mt-2">
            <div class="text-10 text-a-blue-193591">{{getMissionMessage()}}</div>
            <div class="text-10 text-a-gray-a4a4a4">{{missionValue}}</div>
        </div> -->
        <!-- checkin -->
        <!-- <CheckinList :checkinList="missionValue"
                    :isCheckIn="missionCheckin"
                    :missionValue="missionValue"
                    :page="page" /> -->
        <NewCheckinList data-cy="component_mission_checkin_list" :isCheckIn="missionCheckin" />
    </div>
</template>
<script>
//mixin
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
//component
import NewCheckinList from './NewCheckinList.vue';
export default {
    name: "Mission",
    mixins: [AuthStatusMixin, LocaleMixin, ModalMixin],
    props: {
        isCheckIn:  { type: Boolean, required: true },
        missionCheckin: { type: Number },
        missionValue: { type: Number },
        progressMission: { type: Number },
        imgProgress: { type: Number },
        page: { type: Object }
    },
    components: {
        NewCheckinList
    },
    methods: {
        getMissionMessage: function () {
            var missionText = this.lbl.mission.checked + (this.missionCheckin > 1 && this.localeCode == 1033 ? 's' : '');
            return this.FilterStringFormat(missionText, (this.missionCheckin));
        },
        clickDetail: function() {
            this.tracking.event('mission_checkin', 'mission_checkin_detail', null, null);

            this.$router.push('/mission/detail');
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
#progress_bar {
    position: relative;
    height: 8px;
    width: 100%;
    border-radius: 20px;
    background-color: $progress-bar-gray;
    margin: auto;
    #current_bar {
        border-radius: 20px;
        height: 12px;
        position: absolute;
        top: -2.5px;
    }
    .icon-fish {
        img {
            position: absolute;
            top: -14px;
            margin-left: -13px;
        }
    }
}

</style>
